/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './..\\convo\\defs.defs.js'

const $nsid = 'chat.bsky.group.removeMembers'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  convoId: /*#__PURE__*/ l.string(),
  members: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' }), {
    minLength: 1,
  }),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convo: /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
    (() => ConvoDefs.convoView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Removes members from a group. This deletes convo memberships, doesn't just set a status. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidConvo',
  'InsufficientRole',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
